import React from 'react'
import styles from './styles.module.css'

const DressCode = () => {
  // Примеры образов
  const outfitExamples = [
    {
      id: 1,
      title: "Женский образ",
      description: "Коктейльное или вечернее платье,нарядный брючный или юбочный костюм, туфли на каблуке",
      colors: ["#f9e3e6", "#fb968c", "#f4b07f", "#f6e4a6", "#bdc8c0", "#c3dbff"],
      image: "/dress-kod-women-2.webp"
    },
    {
      id: 2,
      title: "Мужской образ",
      description: "Классический смокинг или костюм, туфли галстук, или бабчка на усмотрение",
      colors: ["#D2B48C", "#BC8F8F", "#F5DEB3", "#000", "#FFF"],
      image: "/dress-kod-men-2.webp"
    }
  ]

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.flowerDecoration}></div>
        <h2 className={styles.title}>Дресс-код</h2>
        <p className={styles.subtitle}>Old money style в пастельных тонах</p>
      </div>

      <div className={styles.content}>
        <div className={styles.description}>
          <p>
            Мы будем рады, если вы поддержите элегантную атмосферу нашего вечера, 
            выбрав наряды в стиле "Old money" и пастельной цветовой гамме.
          </p>
          <p>
            Это создаст гармоничную и изысканную атмосферу праздника.
          </p>
        </div>

        <div className={styles.colorPalette}>
          <h3 className={styles.sectionTitle}>Рекомендуемая палитра</h3>
          <div className={styles.colors}>
            {["#f9e3e6", "#fb968c", "#f4b07f", "#f6e4a6", "#bdc8c0", "#c3dbff"].map((color, index) => (
              <div 
                key={index}
                className={styles.colorSample}
                style={{ backgroundColor: color }}
              />
            ))}
          </div>
        </div>

        <div className={styles.outfits}>
          <h3 className={styles.sectionTitle}>Примеры образов</h3>
          <div className={styles.outfitGrid}>
            {outfitExamples.map(outfit => (
              <div key={outfit.id} className={styles.outfitCard}>
                <div 
                  className={styles.outfitImage}
                  style={{ backgroundImage: `url(${outfit.image})` }}
                />
                <div className={styles.outfitInfo}>
                  <h4>{outfit.title}</h4>
                  <p>{outfit.description}</p>
                  <div className={styles.outfitColors}>
                    {outfit.colors.map((color, idx) => (
                      <div 
                        key={idx}
                        className={styles.smallColor}
                        style={{ backgroundColor: color }}
                      />
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.note}>
          <p>
            * Пожалуйста, избегайте ярких неоновых цветов в одежде, 
            чтобы сохранить нежную атмосферу вечера.
          </p>
        </div>
      </div>
    </div>
  )
}

export default DressCode